import api, { OpenAxios } from "./api";
import TokenService from "./token.service";

class AuthService {
    login(values) {
        return api
            .post("/token/", values)
            .then((response) => {
                if (response.data.access) {
                    TokenService.setUser(response.data);
                }

                return response.data;
            });
    }

    logout() {
        TokenService.removeUser();
    }

    register(values) {
        return api.post("/signup/", values);
    }

    getCurrentUser() {
        return TokenService.getUser();
    }

    getTac(userId) {
        return api.post(`/signup/${userId}/get-tac/`);
    }

    verifyTac({ userId, code }) {
        return api.post(`/signup/${userId}/verify-tac/`, { "tac": code });
    }

    activate({ userId, values }) {
        return api.post(`/signup/${userId}/activate/`, values);
    }

    getBanklist() {
        return OpenAxios.get(`/banks/`);
    }

    changePassword({values, userId}) {
        return api.put(`/change-password/${userId}/`, values)
    }
}

export default new AuthService();
